var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.fullPath != '/pdf' && _vm.$route.path != '/policy')?_c('header-vue'):_vm._e(),_c('router-view'),(_vm.$route.fullPath != '/pdf' && _vm.$route.path != '/policy')?_c('footer-vue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }